import type {
  GenerateFlowField,
  GenerateFlowInputStep,
} from "../data/generateFlowInputFields";

export const fieldValueKey = (stepId: string, fieldKey: string): string =>
  `${stepId}__${fieldKey}`;

export const getFieldValue = (
  stepId: string,
  field: GenerateFlowField,
  values: Readonly<Record<string, string>>,
): string => {
  const key = fieldValueKey(stepId, field.key);
  if (values[key] !== undefined) {
    return values[key];
  }
  return field.value ?? "";
};

export const isInputSectionValid = (
  step: GenerateFlowInputStep,
  values: Readonly<Record<string, string>>,
): boolean =>
  step.fields.every((field) => {
    if (!field.required) {
      return true;
    }
    return getFieldValue(step.id, field, values).trim().length > 0;
  });

export const areAllInputSectionsValid = (
  steps: readonly GenerateFlowInputStep[],
  values: Readonly<Record<string, string>>,
): boolean => steps.every((step) => isInputSectionValid(step, values));

export const getCompletedSectionIndexes = (
  steps: readonly GenerateFlowInputStep[],
  values: Readonly<Record<string, string>>,
): ReadonlySet<number> => {
  const completed = new Set<number>();
  steps.forEach((step, index) => {
    if (isInputSectionValid(step, values)) {
      completed.add(index);
    }
  });
  return completed;
};
